import Slide, { SlideProps } from "./Slide";
import Slider, { SliderActions, SliderProps } from "./Slider";

export { Slide, SlideProps, SliderActions, SliderProps };
export default Slider;
